import { defineMessages } from 'react-intl';

export const currentPlanDisplayMessages = defineMessages({
  clinicianVisitPlanName: {
    defaultMessage: 'Clinician Standard',
    id: 'SJEcwEm5FE',
    description:
      'Display name for Clinician Pro on a standard seat when Clinician Max beta is enabled',
  },
  clinicianMaxPlanName: {
    defaultMessage: 'Clinician Max',
    id: 'sqj3M7LaOD',
    description:
      'Display name for Clinician Pro on a Max seat when Clinician Max beta is enabled',
  },
  practiceStandardPlanName: {
    defaultMessage: 'Practice Standard',
    id: 'sMn5xwWLQr',
    description: 'Display name for the Practice Standard plan in Heidi 2',
  },
  practiceMaxPlanName: {
    defaultMessage: 'Practice Max',
    id: 'URKV0C8zzC',
    description: 'Display name for the Practice Max plan in Heidi 2',
  },
  practiceMaxPlanDescription: {
    defaultMessage:
      'Team, Scribe, unlimited Evidence and maximum agentic usage for your whole clinic.',
    id: 'CSlknVNJ6M',
    description:
      'Current plan description in billing settings for a Practice Max seat in Heidi 2',
  },
});
